import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PermissionsEnum } from 'src/app/constants/settings.enum';
import { Plugin } from 'src/app/models/plugin';

@Component({
  selector: 'app-other',
  templateUrl: './other.component.html'
})
export class OtherComponent {
  
  // needed to setup Directives of Permission
  permissionEnum = PermissionsEnum;
  
  @Output('UpdateOrganisationPlugins') updateOrganisationPlugins: EventEmitter<any> = new EventEmitter<any>();
  @Input('Plugins') set plugins(plugins: any){
    this.auditCase = plugins.AuditCase;
    this.caseWare = plugins.CaseWare;
    this.map = plugins.MAP;
    this.sharePoint = plugins.SharePoint;
    this.oneDrive = plugins.OneDrive;
    this.teams = plugins.Teams;
  }

  auditCase!: Plugin;
  caseWare!: Plugin;
  map!: Plugin;
  sharePoint!: Plugin;
  oneDrive!: Plugin;
  teams!: Plugin;

  toggleShowPlugins(event: any){
    let key =(event.target as HTMLInputElement).id;
    let checked = (event.target as HTMLInputElement).checked;
    this.updateOrganisationPlugins.emit([{PluginCode:key, Enabled:checked }]);
  }

}
